export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f75cd54b219ae5c41b7546c84609aaf1ba2bebdc8&name=fetchTypeahead!'